import { LicenseInfo } from '@mui/x-license';
import {
  StylesProvider,
} from "@material-ui/core/styles";

import { DeepPartial } from "../types";

import "./global.css";

import { AppThemeProvider } from "./theme";
import { AppThemeProperties } from './types'

LicenseInfo.setLicenseKey('83645019e119a2e01d3340baf30ef9fdTz0xMTgwNTIsRT0xNzg3NDQzMTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

interface StyleProvidersProps {
  children: React.ReactNode;
  renderCssBaseline?: boolean;
  theme?: DeepPartial<AppThemeProperties>;
}

/**
 * Should wrap the application.
 */
export function StyleProviders({
  children,
  theme,
  renderCssBaseline
}: StyleProvidersProps): JSX.Element {
  return <StylesProvider injectFirst>
    <AppThemeProvider theme={theme ?? {}} renderCssBaseline={renderCssBaseline}>
      {children}
    </AppThemeProvider>
  </StylesProvider>
}
